import { stringify } from "querystring";

import { HttpService, accessTokenProvider } from "@common";
import { AuthorizationType, IUser } from "@common/models";

class AdminService {
  private http = new HttpService(accessTokenProvider);

  public getUsers(
    skip: number,
    filter: string = "",
    active: boolean = false,
    sort: string = "Name",
    reverseOrder: boolean = false
  ) {
    const query = stringify({
      skip,
      filter,
      active,
      sort,
      reverseOrder
    });

    return this.http
      .fetch(`${urls.auth}/users/?${query}`)
      .then(res => res.json());
  }

  public updateUserAuthorizations(
    userId: string,
    authorizations: AuthorizationType[]
  ): Promise<IUser> {
    const url = `${urls.auth}/users/${userId}/authorization`;
    return this.http
      .fetch(url, {
        method: "POST",
        body: JSON.stringify({ claims: authorizations })
      })
      .then(res => res.json());
  }

  public updateUserApiKey(
    userId: string,
    newDate: string,
    newName: string,
    oldName: string
  ): Promise<IUser> {
    const url = `${urls.auth}/apikeys/${userId}`;
    return this.http
      .fetch(url, {
        method: "PUT",
        body: JSON.stringify({ newDate, newName, oldName })
      })
      .then(res => res.json());
  }

  public deleteUserApiKey(userId: string, tokenName: string): Promise<IUser> {
    const url = `${urls.auth}/apikeys/${userId}/${tokenName}`;
    return this.http.fetch(url, { method: "DELETE" }).then(res => res.json());
  }

  public createUserApiKey(userId: string): Promise<IUser> {
    const url = `${urls.auth}/apikeys/${userId}`;
    return this.http.fetch(url, { method: "POST" }).then(res => res.json());
  }

  public removeDevice(userId: string, deviceId: string): Promise<IUser> {
    const url = `${urls.auth}/devices/${btoa(deviceId)}/${userId}`;
    return this.http.fetch(url, { method: "DELETE" }).then(res => res.json());
  }

  public approveDevice(userId: string, deviceId: string): Promise<IUser> {
    const url = `${urls.auth}/devices/${btoa(deviceId)}/${userId}`;
    return this.http.fetch(url, { method: "POST" }).then(res => res.json());
  }
}

export default AdminService;
